/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_It_Skills_TitleInputs */

const en_register_onboarding_personal_info_it_skills_title = /** @type {(inputs: Register_Onboarding_Personal_Info_It_Skills_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software and IT skills`)
};

const de_register_onboarding_personal_info_it_skills_title = /** @type {(inputs: Register_Onboarding_Personal_Info_It_Skills_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software- und IT-Kenntnisse`)
};

/**
* | output |
* | --- |
* | "Software and IT skills" |
*
* @param {Register_Onboarding_Personal_Info_It_Skills_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_it_skills_title = /** @type {((inputs?: Register_Onboarding_Personal_Info_It_Skills_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_It_Skills_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_it_skills_title(inputs)
	return en_register_onboarding_personal_info_it_skills_title(inputs)
});